
<template>
  <div id="app">
    <!-- 全局提示，紧急发布时启动 -->
    <!-- <common-tips/> -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>
<style lang="less">
  @import 'assets/style/base.less';
</style>
